import React from 'react';
import { BookingStatus, BOOKING_STATUS_LABELS } from '../../types/booking';

interface Props {
  status: BookingStatus;
}

const CONFIG: Record<BookingStatus, string> = {
  [BookingStatus.Pending]: 'bg-amber-50 text-amber-700 border-amber-200',
  [BookingStatus.Confirmed]: 'bg-strivre-lightnavy text-strivre-navy border-strivre-navy/20',
  [BookingStatus.Completed]: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  [BookingStatus.Cancelled]: 'bg-strivre-lightburgundy text-strivre-burgundy border-strivre-burgundy/20',
  [BookingStatus.NoShow]: 'bg-strivre-softgrey text-slate-600 border-strivre-lightnavy',
};

export default function BookingStatusBadge({ status }: Props) {
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded text-xs font-semibold border ${CONFIG[status]}`}>
      {BOOKING_STATUS_LABELS[status]}
    </span>
  );
}

